import React from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { useState } from 'react';
import { publisherJson } from './publisher';
import 'bootstrap/dist/css/bootstrap.min.css';
import './articleManager.css';
import ArticleService from '../../services/articleService/articleService';

function ArticleManager () {
  const projectCollection = '/articles';
  const articleService = new ArticleService(projectCollection); // nosql database service
  /*********************** Hooks varaiables start here*************************/
  const [title, setTitle] = useState(''); // title hook
  const [description, setDescription] = useState(''); // desc hook
  const [articleLink, setArticleLink] = useState(''); // link hook
  const [publisherInfo, setPublisherInfo] = useState(''); // image url hook
  /************************ Hooks varaiables end here**************************/

  /******************Hooks functions start here********************************/
  const titleChange = (event) => {
     setTitle(event.target.value );
   };// title hook function
   const descriptionChange = (event) => {
      setDescription(event.target.value );
    };// desc hook function
  const articleLinkChange = (event) => {
     setArticleLink(event.target.value );
   }; // link hook function
  const publisherInfoChange = (event) => {
     setPublisherInfo(event.target.value);
   }; // country code hook function
   const publisher = publisherJson.map((data, key) =>
   <MenuItem
   value={data}>
   {data.publisher}
   </MenuItem>);

  const submitClick = async () => {
    const data = {
      'title' : title.trim(),
      'description' : description.trim(),
      'articleLink' : articleLink.trim(),
      'imageUrl' : publisherInfo.publisherImage.trim(),
      'alt' : publisherInfo.publisher.trim(),
      'addedTime' : new Date()
    }
    if((!data.title && !data.description && !data.articleLink && !data.imageUrl &&
        !data.alt)){
      window.alert('Fill all fields')
      return;
    }
    console.log(data);
    await articleService.addData(data);
    window.location.reload();
   };

  return (
  <div className="articleManager">
  <span>
  <h2 className="articleManager-Header">Add Articles</h2>
  &nbsp;
  </span>

  <span>
  <TextField
  color="secondary"
  label="Title *"
  variant="outlined"
  value={title}
  onChange={titleChange}
  className="articleManager-Element"/>
  </span>

  <span>
  <TextField
  color="secondary"
  label="Description *"
  variant="outlined"
  value={description}
  onChange={descriptionChange}
  className="articleManager-Element"/>
  </span>

  <span>
    <InputLabel id="select-label">Publisher *</InputLabel>
        <Select
          className="articleManager-Select"
          labelId="demo-simple-select-label"
          id="select-code"
          value={publisherInfo}
          onChange={publisherInfoChange}>
          {publisher}
        </Select>
  </span>

  <span>
  <TextField
  color="secondary"
  label="Article Link *"
  variant="outlined"
  value={articleLink}
  onChange={articleLinkChange}
  className="articleManager-Element"/>
  </span>

  <span>
  <Button variant="outlined"
   onClick={submitClick}
   color="secondary"
   className="articleManager-ButtonSubmit">
   Submit
   </Button>
   </span>

  </div>
  );
}
export default ArticleManager;
